exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2MoeJ{-ms-flex:0 0 auto;flex:0 0 auto;height:60px;padding:0 18px 0 30px;color:#000;background:transparent}._2rMEn{-ms-flex:1 1 auto;flex:1 1 auto;margin:30px 0 25px;font-size:18px;font-weight:400;text-align:center}._1X650{-ms-flex:0 0 auto;flex:0 0 auto;position:absolute;z-index:10;top:-20px;right:0;width:auto;height:auto;margin-left:10px;border-radius:50%;font-size:14px;background:transparent;color:hsla(0,0%,100%,.6)}._1X650:hover{background:none}", ""]);

// exports
exports.locals = {
	"header": "_2MoeJ",
	"title": "_2rMEn",
	"close-button": "_1X650",
	"closeButton": "_1X650"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/modal/header/header-mobile.styl
// module id = 662
// module chunks = dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page